import { render } from "./EditUserPage.vue?vue&type=template&id=4b25f0ff&ts=true"
import script from "./EditUserPage.vue?vue&type=script&lang=ts"
export * from "./EditUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__